import { StyleRules, AppBarClassKey } from '@material-ui/core';
import colors from '../colors.module.scss';

export const MuiAppBar: Partial<StyleRules<AppBarClassKey, {}>> = {
  colorDefault: {
    backgroundColor: colors.white,
  },
};
